"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    Progress: ()=>Progress
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
const progress_namespaceObject = require("@base-ui-components/react/progress");
const index_cjs_namespaceObject = require("../../utils/index.cjs");
const external_Progress_variants_cjs_namespaceObject = require("./Progress.variants.cjs");
const isIndeterminate = (value)=>null === value;
const defaultProps = {
    min: 0,
    max: 100
};
const Progress = (props)=>{
    const { value, min = defaultProps.min, max = defaultProps.max, className, rounded, emphasis, ...restProps } = props;
    const { rootSlot, trackSlot, indicatorSlot } = (0, external_Progress_variants_cjs_namespaceObject.progressVariants)({
        rounded,
        emphasis,
        indeterminate: isIndeterminate(value)
    });
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(progress_namespaceObject.Progress.Root, {
        value: value,
        min: min,
        max: max,
        className: (0, index_cjs_namespaceObject.cn)(rootSlot(), className),
        ...restProps,
        children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(progress_namespaceObject.Progress.Track, {
            className: trackSlot(),
            children: /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(progress_namespaceObject.Progress.Indicator, {
                className: indicatorSlot()
            })
        })
    });
};
exports.Progress = __webpack_exports__.Progress;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "Progress"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
